module.exports = __webpack_public_path__ + "static/media/3.e65a6248.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/3.jpg
// module id = 380
// module chunks = 0